/** Registers entityFeedbackApiRef natively. */
import {
  createFrontendModule,
  ApiBlueprint,
} from '@backstage/frontend-plugin-api';
import { createApiFactory, discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';
import {
  entityFeedbackApiRef,
  EntityFeedbackClient,
} from '@backstage-community/plugin-entity-feedback';

export default createFrontendModule({
  pluginId: 'app',
  extensions: [
    ApiBlueprint.make({
      name: 'entity-feedback-api',
      params: define =>
        define(
          createApiFactory({
            api: entityFeedbackApiRef,
            deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
            factory: ({ discoveryApi, fetchApi }) =>
              new EntityFeedbackClient({ discoveryApi, fetchApi }),
          }),
        ),
    }),
  ],
});
